import { connect, useDispatch } from "react-redux";
import { Action, Dispatch } from "redux";
import Collapse from "../../../../../components/Collpase";
import Loader from '../../../../../components/Loader'
import { Center } from "../../../../../components/StyledComponents";
import { Group } from "../../../../../types";
import {
  Title,
  Paragraph,
  LoaderWrapper,
  LoaderBackground
} from './styles'
import { initialValues, schema } from '../../../../../constants/forms//waiting-list-external-url/edit';
import { updateGroup } from "../../../../../store/actions/group";
import { useMemo, useState } from "react";
import { useWindowSize } from "../../../../../hooks/useWindowSize";
import Input from "../../../../../components/FormikForm/Input";
import Submit from "../../../../../components/FormikForm/Submit";
import { Formik } from "formik";
import { dateSpliter } from "../../../../../helpers/dates-hanlder";

import moment from "moment";
import "moment/locale/es";
import Checkbox from "../../../../../components/FormikForm/Checkbox";

moment.locale("es");

interface ComponentProps {
  group: Group
  updateGroupStates: {
    loading: boolean
    success: boolean
    error: boolean
  }
}

const Component = ({ group, updateGroupStates }: ComponentProps) => {
  const dispatch = useDispatch<Dispatch<Action>>()
  const { isMobile } = useWindowSize()
  const [formSubmmited, setFormSubmmited] = useState(false);

  const onSubmit = ({ values, actions }) => {
    dispatch(updateGroup({ id: group?.id, ...values }))
  };


  const SubscriptionStatus = useMemo(() => {
    const closingDate = group?.registration_closing_date

    if (!closingDate) {
      return <span>Estado actual: Las inscripciones están abiertas.</span>;
    }

    const now = moment();
    const closing = moment(closingDate);

    if (closing.isBefore(now)) {
      return <span>Estado actual: Las inscripciones están cerradas.</span>;
    }

    const duration = moment.duration(closing.diff(now));
    const humanized = duration.humanize(true); // 'en 3 días', 'en 2 horas', etc.

    return <span>Estado actual: Las inscripciones se cierran {humanized}</span>;
  }, [group])

  return (
    <Collapse
      toggleIcon=""
      style={{ backgroundColor: 'white', padding: !isMobile ? '30px' : '10px' }}
      toggleLabel={
        <Center column horizontal="left" vertical="top">
          <Title style={{ margin: 0 }}>Link Lista de espera</Title>
          <div style={{ height: 6 }} />
          <Paragraph style={{ textAlign: isMobile ? 'left' : 'center' }}>Redirige a los usuarios a una lista de espera cuando las inscripciones estén cerradas.</Paragraph>
        </Center>
      }
    >
      <div style={{ height: 28 }} />

      <Center column={isMobile} horizontal="left" vertical="top" gap={25} >
        <Formik
          initialValues={{
            waiting_list_external_url: group?.waiting_list_external_url || '',
            waiting_list_cta_text: group?.waiting_list_cta_text || ''
          }}
          onSubmit={(values, actions) => {
            if (onSubmit) onSubmit({ values, actions });
          }}
          validateOnChange={false}
          validateOnBlur={formSubmmited}
          validationSchema={schema}
          enableReinitialize
        >
          {({
            touched,
            errors,
            values,
            setFieldValue,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => {
            return (
              <form
                className="theme-form"
                onSubmit={(event) => {
                  setFormSubmmited(true);
                  handleSubmit(event);
                }}
                style={{ width: "100%" }}
                id="waiting_list_external_url-form"
              >

                <Input
                  name="waiting_list_external_url"
                  error={errors["waiting_list_external_url"]}
                  touched={touched["waiting_list_external_url"]}
                  value={values["waiting_list_external_url"]}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="https://"
                  style={{ width: "100%" }}
                  options={{
                    label: "URL externa",
                    marginBottom: 20,
                  }}
                />

                <Input
                  name="waiting_list_cta_text"
                  error={errors["waiting_list_cta_text"]}
                  touched={touched["waiting_list_cta_text"]}
                  value={values["waiting_list_cta_text"]}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="EJ: Reservar mi lugar"
                  style={{ width: "100%" }}
                  options={{
                    label: "Texto del botón",
                    marginBottom: 0,
                  }}
                />
              </form>
            )
          }}
        </Formik>

      </Center>

      <div style={{ height: 26 }} />

      <Paragraph>
        {SubscriptionStatus}
      </Paragraph>

      <div style={{ height: 26 }} />

      <Submit
        options={{
          type: "filled",
          size: "lg",
          skin: "purple",
        }}
        isSubmmiting={updateGroupStates.loading}
        disabled={updateGroupStates.loading}
        form="waiting_list_external_url-form"
      >
        Guardar
      </Submit>

      <div style={{ height: 26 }} />

    </Collapse>
  )
}

const state = ({ groupStore, welcomeContentStore }) => {
  const { data: group, states: groupStates } = groupStore.group;
  const { data: welcomeContentSection, states: welcomeContentSectionStates } = welcomeContentStore.welcomeContentSection;
  const { states: updateGroupStates } = groupStore.updateGroup;

  return {
    group,
    groupStates,
    welcomeContentSection,
    welcomeContentSectionStates,
    updateGroupStates
  };
};

export default connect(state)(Component);